import { render, staticRenderFns } from "./transmit.vue?vue&type=template&id=65edf2f8"
import script from "./transmit.vue?vue&type=script&lang=js"
export * from "./transmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports